// extracted by mini-css-extract-plugin
export default {"h4":"style_h4__gbJ38"};